import { Alert } from "@instructure/ui";
import { t } from "i18next";
import { useLocation } from "react-router";

const Error = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  return (
    <Alert variant="error" margin="small">
      {t("errorPage." + (useQuery().get("type") || "general"))}
    </Alert>
  );
};

export default Error;
